module.exports = __webpack_public_path__ + "img/mapIcon.f36b70c1.png";